import { IHasErrorMessage } from '@/interfaces';

const FormLabelErrorMessage = ({ errorMessage }: IHasErrorMessage) => {

  if (!errorMessage) {
    return <></>;
  }

  return (
    <p className='text-sm font-medium text-red-500 text-center'>
      {errorMessage}
    </p>
  );

};

export default FormLabelErrorMessage;
